/**
 * Utility functions for managing overlay-related body attributes
 */

/**
 * Adds a data attribute to the body element to indicate an overlay is open
 * This is used to apply CSS styles that prevent pull-to-refresh on mobile
 */
export function addOverlayOpenAttribute() {
	if (typeof document !== "undefined") {
		document.body.setAttribute("data-overlay-open", "true");
	}
}

/**
 * Removes the overlay open data attribute from the body element
 */
export function removeOverlayOpenAttribute() {
	if (typeof document !== "undefined") {
		document.body.removeAttribute("data-overlay-open");
	}
}
